export const SET_MAP = 'map:set';
export const UPDATE_MAP = 'map:update';
export const SET_SEARCH = 'search:set';
export const UPDATE_SEARCH = 'search:update';
export const SET_QUERY = 'search:query:set';
export const SET_RESPONSE = 'search:response:set';
